import type { CSSProperties } from 'react';
import { ShareIcon } from './ShareIcon';

type Props = {
  name: string;
  size?: number;
  className?: string;
  style?: CSSProperties;
  'aria-hidden'?: boolean;
};

/**
 * Material Symbols Outlined icon. Renders the icon character via the Material
 * Symbols font (loaded by <WebFontLinks />). Variation settings are pinned to
 * wght:400, FILL:0, GRAD:0, opsz:24 per the design system.
 * Share names are the one exception and render the canonical original glyph.
 *
 * Usage:
 *   <MaterialSymbol name="search" />
 *   <MaterialSymbol name="settings" size={22} />
 */
export function MaterialSymbol({
  name,
  size,
  className,
  style,
  'aria-hidden': ariaHidden = true,
}: Props) {
  const isShare = name === 'share' || name === 'ios_share';
  return (
    <span
      className={
        className
          ? `material-symbols-outlined ${className}`
          : 'material-symbols-outlined'
      }
      aria-hidden={ariaHidden}
      style={size ? { fontSize: size, ...style } : style}
    >
      {isShare ? <ShareIcon size="1em" color="currentColor" /> : name}
    </span>
  );
}
